module.exports = __webpack_public_path__ + "fonts/OpenSans600.19baaf0c.eot";